export const ROUTE_HOME = 'route/ROUTE_HOME';

export const ROUTE_EVENTS = 'route/ROUTE_EVENTS';
export const ROUTE_EVENTS_SHOW = 'route/ROUTE_EVENTS_SHOW';

export const ROUTE_SEARCH = 'route/ROUTE_SEARCH';
export const ROUTE_SEARCH_QUERY_TEXT = 'route/ROUTE_SEARCH_QUERY_TEXT';

export const ROUTE_POLICIES = 'route/ROUTE_POLICIES';

export const ROUTE_STATIC_PLACEHOLDER = 'route/ROUTE_STATIC_PLACEHOLDER';

export const ROUTE_DEMO = 'route/ROUTE_DEMO';



// WEBPACK FOOTER //
// ./src/routes/types.js